import { login, getWallet, getInfo } from '@/api/index'
import { setToken, removeToken } from '@/utils/auth'
import { ElMessageBox, ElMessage } from 'element-plus'
import router from '@/router'
export default {
    // 用户登录
    login({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
          login(userInfo).then(res => {
            setToken(res.token)
            commit('SET_TOKEN', res.token)
            localStorage.setItem('token',res.token)
            localStorage.setItem('userName',userInfo.userName)
            getInfo().then(res => {
              console.log(res.data.recommendUserId)
              localStorage.setItem('recommendUserId',res.data.recommendUserId)
              commit('SET_USER_DATA', res.data)
              resolve()
            }).catch(error => {
              reject(error)
            })
            resolve()
          }).catch(error => {
            reject(error)
          })
        })
      },
    // 用户登出
    logout({ commit }) {
      commit('CLEAR_USER_DATA')
      commit('SET_TOKEN', null)
      localStorage.setItem('token', null)
      localStorage.setItem('userName','')
      removeToken()
    },
    // 获取钱包
    getwallet({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        getWallet(userInfo).then(res => {
          if(res.code == '40004') {
            ElMessageBox.alert('登录状态已过期，请重新登录', '系统提示', {
              confirmButtonText: '重新登录',
            }).then(() => {
              router.push({ path: '/login' })
            })
          } else {
            commit('UPDATE_WALLET', res.data.realScore)
            resolve()
          }
          
        }).catch(error => {
          reject(error)
        })
      })
    },
  }